import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    CircularProgress,
    FormControl,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TolCurrencyTotals } from "../Generated/avroGraphqlDuty";

interface Props {
    expanded: boolean;
    accordianIndexValue: number;
    accordionClicked(arg0: number): void;
    error: any;
    data: any;
    loading: boolean;
}

export default function TolCurrencySection(props: Props): JSX.Element {
    const theme = useTheme();
    const isMedium = useMediaQuery(theme.breakpoints.up("sm"));

    let horizontalPadding = 4;

    if (isMedium) horizontalPadding = 6;

    if (props.error) return <>Error fetching TOL Currency</>;
    return (
        <>
            <FormControl fullWidth sx={{ px: horizontalPadding }}>
                <Accordion sx={{ background: "#F7F8F9" }} expanded={props.expanded} onChange={() => props.accordionClicked(props.accordianIndexValue)}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Grid container justifyContent={"space-between"} alignItems={"center"}>
                            <Typography variant="button" fontSize={18} marginLeft={2}>
                                TOL CURRENCY
                            </Typography>
                            {props.loading ? <CircularProgress size={25} sx={{ mr: 2 }} /> : null}
                        </Grid>
                    </AccordionSummary>
                    {!props.loading && props.data && props.data.getTolCurrencyByPersonAndDate ? (
                        <AccordionDetails>
                            <TableContainer component={Paper} sx={{ mt: 2 }}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>A/C TYPE</TableCell>
                                            <TableCell align="center">TOTAL TAKEOFFS</TableCell>
                                            <TableCell align="center">TOTAL LANDINGS</TableCell>
                                            <TableCell align="right">EXPIRY</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {props.data.getTolCurrencyByPersonAndDate.totals?.map((row: TolCurrencyTotals) => {
                                            const expiry = props.data.getTolCurrencyByPersonAndDate.expirations?.find(
                                                (ele: TolCurrencyTotals) => ele?.aircraft_type_id === row?.aircraft_type_id
                                            )?.expiry;
                                            return (
                                                <TableRow
                                                    key={row?.aircraft_type}
                                                    sx={{
                                                        "&:last-child td, &:last-child th": { border: 0 },
                                                        "&:nth-of-type(odd)": {
                                                            backgroundColor: "white",
                                                        },
                                                        "&:nth-of-type(even)": {
                                                            backgroundColor: "#f2f2f2",
                                                        },
                                                    }}>
                                                    <TableCell component="th" scope="row">
                                                        {row?.aircraft_type}
                                                    </TableCell>
                                                    <TableCell align="center">{row?.total_takeoff}</TableCell>
                                                    <TableCell align="center">{row?.total_landing}</TableCell>
                                                    <TableCell align="right">{expiry}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </AccordionDetails>
                    ) : null}
                </Accordion>
            </FormControl>
        </>
    );
}
